import React, { useState } from 'react';
import Logo from "../images/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return (
    <div>
      <div className="navbar-area">
        <div className="praneesh-responsive-nav">
          <div className="container">
            <div className="praneesh-responsive-menu">
              <div className="logo">
                <a href="/">
                  <img src={Logo} className="white-logo" alt="logo" />
                  <img src={Logo} className="black-logo" alt="logo" />
                </a>
              </div>
              <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
                <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
              </div>
            </div>
          </div>
        </div>
        <div className={`praneesh-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="container">
            <nav className="navbar navbar-expand-md navbar-light">
              <a className="navbar-brand" href="/">
                <img src={Logo} className="white-logo" alt="logo" />
                <img src={Logo} className="black-logo" alt="logo" />
              </a>
              <div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a href="/" className="nav-link">Home</a>
                  </li>
                  <li className="nav-item">
                    <a href="about" className="nav-link">About</a>
                  </li>
                  <li className="nav-item">
                    <a href="service" className="nav-link">Services <i className="fas fa-chevron-down"></i></a>
                    <ul className="dropdown-menu">
                      <li className="nav-item">
                        <a href="service-android" className="nav-link">Android Application</a>
                      </li>
                      <li className="nav-item">
                        <a href="service-ios" className="nav-link">IOS Application</a>
                      </li>
                      <li className="nav-item">
                        <a href="service-website" className="nav-link">Website Development</a>
                      </li>
                      <li className="nav-item">
                        <a href="service-webapp" className="nav-link">Web App Development</a>
                      </li>
                      <li className="nav-item">
                        <a href="service-ecom" className="nav-link">E-Commere Development</a>
                      </li>
                      <li className="nav-item">
                        <a href="service-poster" className="nav-link">Social Media Poster Design</a>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a href="contact" className="nav-link">Contact</a>
                  </li>
                </ul>
                <div class="other-option">
                  <a className="default-btn" href="contact">Get It Support</a>
                </div>
              </div>
            </nav>
          </div> :
        </div>
      </div>
      <div className="go-top">
        <i className="fas fa-chevron-up"></i>
      </div>
      <a href="https://wa.me/919487924282"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginLeft: '10px', color: '#FFFFFF', fontSize: '24px' }}>
        <FontAwesomeIcon icon={faWhatsapp} /></a>
    </div >
  )
}

export default Header;